import React from "react"

import platformTracking from "@irati-tracking/platform"
import checkoutService from "@irati/checkout/services/checkout"
import {FormattedMessage, useIntl} from "@irati/utils/lang"
import IconText from "@irati/ui/src/IconText"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import {SpendStatementItemTransferOrderTotal} from "@irati/types"
import {IconTypes} from "@irati/ui/src/Icon"
import {useAppRouteContext} from "@irati/utils/history"
import styled from "styled-components"
import {RouterLink} from "@irati/ui/src/Link"
import {minWidthMedia} from "@irati/ui/src/global/media"
import Wrapper from "../Wrapper"
import SecondaryDetailsItem from "../Item"

const StyledWrapper = styled(Wrapper)`
  margin-top: 10px;
`

const StyledRouterLink = styled(RouterLink)`
  display: inline-block;
  margin-top: 30px;

  ${minWidthMedia.tablet`
    padding-left: 35px;
    margin: 0 0 0 auto;
  `}
`

interface Props {
  data: {
    redemptionUuid?: string
    orderTotal?: SpendStatementItemTransferOrderTotal
  }
}

export default function Spend({data: {redemptionUuid, orderTotal}}: Props) {
  const {formatNumber} = useIntl()
  const {apps} = useAppRouteContext()

  return (
    <StyledWrapper>
      {orderTotal?.value && (
        <SecondaryDetailsItem
          isFirstItem
          text={
            <FormattedMessage
              id="wallet.secondaryDetails.spend.orderTotal"
              values={{
                amount: formatNumber(orderTotal.value, {style: "currency", currency: orderTotal.currency})
              }}
            />
          }
        />
      )}
      <Flex marginLeft="auto" marginRight={redemptionUuid ? "0" : mainTheme.spacing.four}>
        {redemptionUuid && (
          <StyledRouterLink
            app={apps.PERKS}
            async
            onClick={async () => {
              platformTracking.click("order_history", {source: "wallet_transaction"})
              const {
                fullRedemptions: [{uuid}]
              } = await checkoutService.getCheckout(redemptionUuid)
              return `/account/my-perks/new?redemptionUuid=${uuid}`
            }}>
            <IconText icon={IconTypes.angleRight} iconPosition="right">
              <FormattedMessage id="wallet.secondaryDetails.spend.myPerksButtonText" />
            </IconText>
          </StyledRouterLink>
        )}
      </Flex>
    </StyledWrapper>
  )
}
